<template>
  <div class="container-xl">
    <div class="card col-lg-12 mt-2">
      <div class="card-header border-0 justify-content-between">
        <div class="card-title">
          AWA Report
        </div>
        <div class="flex flex-row mb-2 pr-2 float-right">
          <el-date-picker
              v-model="search_date"
              type="daterange"
              size="small"
              :picker-options="datePickerOptions"
              class="mr-2"
              range-separator="To"
              value-format="yyyy-MM-dd"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
            
          <el-button :loading="isLoading" type="info" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button>
          <el-button :loading="isLoading" type="primary" @click="downloadHandler" size="small"><font-awesome-icon icon="download"/> Download</el-button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table card-table text-nowrap table-vcenter">
          <thead>
            <tr>
              <th>Disbursement Date</th>
              <th>Employee Name</th>
              <th>Company Name</th>
              <th>Disbursement Amount</th>
              <th>Admin Fee</th>
              <th>Total Transfer</th>
              <th>Invoice Status</th>
              <th>Due Date Invoice</th>
              <th>Total Repayment</th>
              <th>Payment Date</th>
              <th>Processing Fee</th>
            </tr>
          </thead>
          <tbody v-loading="isLoading">
            <tr v-for="(item, i) in list" :key="i">
              <td>{{ item.disburse_at_str }}</td>
              <td>{{ item.employee_name }}</td>
              <td>{{ item.company_name }}</td>
              <td>{{ item.request_amount_str }}</td>
              <td>{{ item.admin_fee_str }}</td>
              <td>{{ item.request_amount_str }}</td>
              <td>
                <span class="tag" 
                      :class="item?.invoice_status_color && item.invoice_status_str !== '-' 
                                ? item.invoice_status_color 
                                : item.installment_invoice_status_color">
                  {{ item?.invoice_status_str && item.invoice_status_str !== '-' 
                        ? item.invoice_status_str 
                        : item.installment_invoice_status_str || '-' }}
                </span>
              </td>
              <td>
                  {{
                    item.invoice_due_date_str !== '-' && item.invoice_due_date_str
                      ? item.invoice_due_date_str
                      : item.installment_due_date_str
                  }}
              </td>
              <td>{{ `Rp.  ${(item.request_amount + item.admin_fee).toLocaleString()}`}} </td>
              <td>
                  {{
                    item.invoice_payment_date_str !== '-' && item.invoice_payment_date_str
                      ? item.invoice_payment_date_str
                      : item.installment_payment_date_str
                  }}
              </td>
               <td> {{ `Rp.  ${(item.processing_fee).toLocaleString() || '0'}`}} </td>
            </tr>
          </tbody>
        </table>
        <el-empty description="No report" v-if="total_rows == 0" :image="emptyStateImage"></el-empty>
      </div>
      <pagination :list="list"
        :total_rows="total_rows"
        :page="search.page"
        :per_page="search.per_page"
        @pageChange="pageChangeHandler"
        />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import emptyStateImage from '@/assets/images/empty-state.png';
import {
  GET_AWA_REPORT,
} from '../../../store/modules/awa';
import Pagination from '../../components/Pagination.vue';

const invoice_status = {
  WAITING_PAYMENT: {
    label: 'Waiting Payment',
    color: 'tag-warning',
  },
  PARTIALLY_PAID: {
    label: 'Partially Paid',
    color: 'tag-info',
  },
  FULLY_PAID: {
    label: 'Paid',
    color: 'tag-success',
  },
  CANCELLED: {
    label: 'Cancelled',
    color: 'tag-danger',
  },
  APPROVED: {
    label: 'Approved',
    color: 'tag-success',
  },
  COMPLETED: {
    label: 'Completed',
    color: 'tag-success',
  },
};

export default {
  components: { Pagination },
  name: 'Report',
  metaInfo: {
    title: 'Advanced Wage Access Report',
  },
  data() {
    return {
      emptyStateImage,
      search_date: [],
      search: {
        start_date: moment().subtract(15, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        page: 1,
        per_page: 20,
      },

      isLoading: false,
      datePickerOptions: {
        disabledDate: (date) => moment(date).isAfter(moment(), 'days'),
      },
      list: [],
      total_rows: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    pageChangeHandler(page) {
      this.search.page = page;
      this.getList();
    },
    searchHandler() {
      this.getList();
    },
    async downloadHandler() {
      try {
        this.isLoading = true;
        const headers = [
          "Disbursement Date",
          "Employee Name",
          "Company Name",
          "Disbursement Amount",
          "Admin Fee",
          "Total Transfer",
          "Invoice Status",
          "Due Date Invoice",
          "Total Payment",
          "Payment Date",
          "Processing Fee"
        ];

        const rows = this.list.map((item) => [
          item.disburse_at_str || "-",
          item.employee_name || "-",
          item.company_name || "-",
          item.request_amount_str || "0",
          item.admin_fee_str || "0",
          item.total_transfer_str || "0",
          item.invoice_status_str || "-",
          item.invoice_due_date_str || "-",
          item.request_amount_str || "0",
          item.invoice_payment_date_str || "-",
          item.processing_fee || "0",
        ]);

        const csvContent = [
          headers.join(","),
          ...rows.map((r) => r.map((v) => `"${v}"`).join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        const dateFilter = Array.isArray(this.search.date_filter)
          ? this.search.date_filter.join("-")
          : "all";
        anchor.href = url;
        anchor.setAttribute("download", `AWA-Report-${dateFilter}.csv`);
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },

    async getList() {
      try {
        this.isLoading = true;
        delete this.search.action;
        if (this.search_date && this.search_date.length) {
          this.search.start_date = moment(this.search_date[0]).format(
            "YYYY-MM-DD"
          );
          this.search.end_date = moment(this.search_date[1]).format(
            "YYYY-MM-DD"
          );
        }
        const { data: response } = await this.$store.dispatch(
          GET_AWA_REPORT,
          this.search
        );
        const { count, data: rows } = response.data;
        // map rows
        this.list = (rows || []).map((v) => {
          v.disburse_at_str = moment(v.disburse_at).format(
            "DD MMM YYYY, HH:mm"
          );
          v.employee_name = v.requestor?.full_name || "-";
          v.company_name = v.company?.name || "-";
          v.total_transfer = v.request_amount - v.admin_fee;

          ["request_amount", "admin_fee", "total_transfer"].forEach((key) => {
            v[`${key}_str`] = `Rp. ${v[key] ? v[key].toLocaleString() : 0}`;
          });

          if (v.invoice_item && v.invoice_item.status) {
            v.invoice_status_str =
              invoice_status[v.invoice_item?.status]?.label || v.invoice_item?.status;
            v.invoice_status_color =
              invoice_status[v.invoice_item?.status]?.color || "tag-default";
          } else {
            v.invoice_status_str = "-";
            v.invoice_status_color = "tag-default";
          }

          const status = v.installments?.[0]?.status;
            if (status) {
              v.installment_invoice_status_str =
                invoice_status[status]?.label || status;

              v.installment_invoice_status_color =
                invoice_status[status]?.color || "tag-default";
            } else {

              v.installment_invoice_status_str = "-";
              v.installment_invoice_status_color = "tag-default";
          }

          const due_date = v.installments?.[0]?.due_date;
            if (due_date) {
              v.installment_due_date_str = moment(due_date).format("DD MMM YYYY");
            } else {
              v.installment_due_date_str = "-";
            }
            const payment_date = v.installments?.[0]?.paid_at;
            if (payment_date) {
              v.installment_payment_date_str = moment(payment_date).format("DD MMM YYYY");
            } else {
              v.installment_payment_date_str = "-";
          }
            
          v.invoice_due_date_str = v.invoice_item?.awa_invoice?.due_date
            ? moment(v.invoice_item.awa_invoice.due_date).format("DD MMM YYYY")
            : "-";

          v.invoice_payment_date_str = v.invoice_item?.awa_invoice?.paid_at
            ? moment(v.invoice_item.awa_invoice.paid_at).format("DD MMM YYYY")
            : "-";

          return v;
        });
        this.total_rows = count;
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
